import { createAction } from '@reduxjs/toolkit';
import type { AppLoadedPayload } from './interfaces';

const appStatedLoaded = createAction<AppLoadedPayload>('app-state:loaded');
const userLoggedOutAction = createAction('user:logged-out');

export const sharedActions = {
  appStatedLoaded,
  userLoggedOutAction,
};